var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1655.119,642.444v14.243a3.423,3.423,0,0,1-3.465,3.378h-3.7a1.279,1.279,0,0,1-1.3-1.263v-1.225a1.279,1.279,0,0,1,1.3-1.263h2.026a1.279,1.279,0,0,0,1.3-1.263V644.079a1.279,1.279,0,0,0-1.3-1.263h-2.026a1.279,1.279,0,0,1-1.3-1.263v-1.225a1.279,1.279,0,0,1,1.3-1.263h3.7A3.423,3.423,0,0,1,1655.119,642.444Zm-15.139,12.483a.434.434,0,0,0,.6,0l1.573-1.535a.407.407,0,0,0,0-.587l-1.5-1.466a.159.159,0,0,1,.116-.273h7.772a.421.421,0,0,0,.426-.415v-2.17a.421.421,0,0,0-.426-.415h-7.772a.159.159,0,0,1-.116-.273l1.5-1.466a.407.407,0,0,0,0-.587l-1.573-1.535a.434.434,0,0,0-.6,0l-4.411,4.3a1.474,1.474,0,0,0,0,2.121Z",
    transform: "translate(-1635.119 -639.066)",
    fill: "#002b49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e088d6af2bbda8ed758238102b932564.svg";
export { ForwardRef as ReactComponent };